module.exports = __webpack_public_path__ + "img/Junk Removal.6b12a59b.svg";